











import { Vue, Component, Prop, Model } from 'vue-property-decorator';
@Component({
  name: 'BaseTab',
})
export default class BaseTab extends Vue {
  @Model('change') selectedValue: any;
  @Prop() value: any;

  get active() {
    return this.selectedValue === this.value;
  }
}
